"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAddress = parseAddress;
exports.formAddressFromSlots = formAddressFromSlots;
exports.parseAddressAsSlots = parseAddressAsSlots;
exports.getAddressComponents = getAddressComponents;
const addresser = __importStar(require("addresser"));
const json_1 = require("./json");
/**
 * Custom fallback parser for address strings.
 *
 * @param formattedAddress
 * @returns Parsed address in the format of IParsedAddress
 */
function customParseAddress(formattedAddress) {
    const parsedAddress = {
        zipCode: "",
        stateAbbreviation: "",
        stateName: "",
        placeName: "",
        addressLine1: "",
        streetNumber: "",
        streetSuffix: "",
        streetName: "",
        id: "",
    };
    const parts = formattedAddress.split(",").map((part) => part.trim());
    if (parts.length === 4) {
        // Format: "Street, City, State/Province PostalCode, Country"
        parsedAddress.addressLine1 = parts[0];
        parsedAddress.placeName = parts[1];
        const statePostal = parts[2].split(" ");
        if (statePostal.length > 1 &&
            /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/.test(statePostal.slice(-2).join(" "))) {
            parsedAddress.stateAbbreviation = statePostal.slice(0, -2).join(" ");
            parsedAddress.zipCode = statePostal.slice(-2).join(" ");
        }
        else {
            parsedAddress.stateAbbreviation = statePostal.slice(0, -1).join(" ");
            parsedAddress.zipCode = statePostal[statePostal.length - 1];
        }
        parsedAddress.stateName = parsedAddress.stateAbbreviation; // Fallback since the full name isn't provided
    }
    else if (parts.length === 3) {
        // Format: "City, State/Province PostalCode, Country"
        parsedAddress.placeName = parts[0];
        const statePostal = parts[1].split(" ");
        if (statePostal.length > 1 &&
            /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/.test(statePostal.slice(-2).join(" "))) {
            parsedAddress.stateAbbreviation = statePostal.slice(0, -2).join(" ");
            parsedAddress.zipCode = statePostal.slice(-2).join(" ");
        }
        else {
            parsedAddress.stateAbbreviation = statePostal.slice(0, -1).join(" ");
            parsedAddress.zipCode = statePostal[statePostal.length - 1];
        }
        parsedAddress.stateName = parsedAddress.stateAbbreviation; // Fallback since the full name isn't provided
    }
    else {
        console.warn("Unexpected address format:", formattedAddress);
    }
    parsedAddress.id =
        `${parsedAddress.placeName}-${parsedAddress.zipCode}-${parsedAddress.addressLine1}`
            .replace(/\s+/g, "-")
            .toLowerCase();
    return parsedAddress;
}
/**
 * Attempts to parse an address from a string.
 *
 * @param address
 * @returns Parsed address in ParsedAddress format
 */
function parseAddress(address) {
    let addressed;
    try {
        addressed = addresser.parseAddress(address);
    }
    catch (e) {
        // Not a valid address
        // Fallback to custom parser
        addressed = customParseAddress(address);
    }
    return addressed;
}
/**
 * Forms an address string from from the slots.
 *
 * @param slots
 * @returns
 */
function formAddressFromSlots(slots) {
    const hasCity = slots.city && slots.city.value;
    const hasState = slots.state && slots.state.value;
    let address = "";
    if (slots.street_number && slots.street_number.value) {
        address += slots.street_number.value + " ";
    }
    if (slots.street && slots.street.value) {
        // make sure we aren't adding the street number twice
        // see if street starts with street number, if it does don't add it
        if (slots.street.value.trim().startsWith(address.trim())) {
            // just replace it since it is a dupe
            address = slots.street.value + " ";
        }
        else {
            address += slots.street.value + " ";
        }
    }
    else if (slots.street_name && slots.street_name.value) {
        address += slots.street_name.value + " ";
    }
    // if we have quadrant and it isn't already in the street name
    if (slots.quadrant &&
        slots.quadrant.value &&
        !address.trim().toLowerCase().endsWith(slots.quadrant.value.toLowerCase())) {
        address += slots.quadrant.value + " ";
    }
    if (hasCity || hasState) {
        address = address.trim();
        address += ", ";
    }
    if (slots.city && slots.city.value) {
        if (hasState) {
            address += slots.city.value + ", ";
        }
        else {
            address += slots.city.value + " ";
        }
    }
    if (slots.state && slots.state.value) {
        address += slots.state.value + " ";
    }
    if (slots.zip && slots.zip.value) {
        address += slots.zip.value;
    }
    return address.trim();
}
/**
 * Attempts to parse an address from a string.
 *
 * @param address
 * @returns
 */
function parseAddressAsSlots(address) {
    const slots = {};
    let addressed;
    try {
        addressed = addresser.parseAddress(address);
    }
    catch (e) {
        // not a valid address
        console.warn(`Unable to parse address string "${address}"`);
    }
    if (addressed) {
        // Pull out the zipCode
        slots.zip = {
            name: "zip",
            value: addressed.zipCode,
        };
        slots.city = {
            name: "city",
            value: addressed.placeName,
        };
        slots.state = {
            name: "state",
            value: addressed.stateName,
        };
        slots.street_number = {
            name: "street_number",
            value: addressed.streetNumber,
        };
        slots.street = {
            name: "street",
            value: addressed.addressLine1,
        };
        slots.street_name = {
            name: "street_name",
            value: addressed.addressLine1.replace(addressed.streetNumber, "").trim(),
        };
        const fullAddress = formAddressFromSlots(slots);
        if (fullAddress) {
            slots.address = {
                name: "address",
                value: fullAddress,
            };
        }
    }
    return slots;
}
/**
 * Takes an input and attempts to parse out all the components
 *
 * It can be passed a partial address object and will attempt to fill in the missing components if a fullAddress is provided
 *
 * @param input
 */
function getAddressComponents(input) {
    let parsedAddress;
    if (typeof input === "string") {
        parsedAddress = parseAddress(input);
    }
    else {
        parsedAddress = input;
    }
    // do some tests to make sure we have all the components
    if (!parsedAddress.stateAbbreviation || !parsedAddress.stateName) {
        // attempt to parse the address section and merge it in
        const parsedFormattedAddress = parseAddress(parsedAddress.formattedAddress || parsedAddress.addressLine1);
        // clean off the parsedFormattedAddress to remove any empty strings & values
        const pruned = (0, json_1.pruneEmpty)(parsedFormattedAddress);
        parsedAddress = Object.assign(Object.assign({}, parsedAddress), pruned);
    }
    if (!parsedAddress.id) {
        // id is just concatenation of the address
        let id = "";
        if (parsedAddress.addressLine1) {
            id += `${parsedAddress.addressLine1},`;
        }
        if (parsedAddress.placeName) {
            id += `-${parsedAddress.placeName},`;
        }
        if (parsedAddress.stateName) {
            id += `-${parsedAddress.stateName}`;
        }
        if (parsedAddress.zipCode) {
            id += `-${parsedAddress.zipCode}`;
        }
        parsedAddress.id = id.replace(/\s+/g, "-");
    }
    return parsedAddress;
}
//# sourceMappingURL=address.js.map